<template>
  <div :class="{ 'empty-style': true, 'full-screen': isFullScreen }">
    <div v-if="!isAllOrNet" class="title">还没有回收数据，多做一些任务吧！</div>
    <div v-else class="title">还没有回收数据，多做一些分享吧！</div>
    <el-button class="mb-10" v-if="!isAllOrNet" size="small" type="primary" icon="el-icon-s-order" @click="assignTask">分配任务</el-button>
    <el-button class="mb-10" v-else size="small" type="primary" icon="el-icon-share" @click="sharelink">分享链接</el-button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GlobalConfig from "@/global/config"

export default {
  name: 'EmptyPrompt',
  props: {
    // 全部、网调 true ； 线下 false
    isAllOrNet: {
      type: Boolean,
      default: true
    },
    isTelephone: {
      type: Boolean,
      default: false
    },
    // 如果是 委托代理菜单 跳转到 发布问卷-委托代理
    isProxyAbout: {
      type: Boolean,
      default: false
    },
    // 全屏样式： 来源进度功能 使用
    isFullScreen: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters(['isSurveyProxy'])
  },
  methods: {
    // 分享链接
    sharelink() {
      this.$router.push({
        path: `/survey/${GlobalConfig.getSurveyId()}/publish/link-qrcode`
      })
    },
    // 分配任务
    assignTask() {
      let urlType
      if (this.isTelephone) {
        urlType = `/survey/${GlobalConfig.getSurveyId()}/publish/cati-interview/index`
      } else {
        urlType = `/survey/${GlobalConfig.getSurveyId()}/publish/random-interview/index`
      }
      // 委托代理菜单的答卷
      if (this.isProxyAbout) {
        urlType = `/survey/${GlobalConfig.getSurveyId()}/publish/agency-interview/index`
      }
      this.$router.push({
        path: urlType
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.title {
  color: #313131;
  font-size: 16px;
  margin-top: 20px;
  margin-bottom: 10px;
}
.empty-style {
  text-align: center;
}
.empty-style.full-screen {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
</style>
